/**
 * Automatically set key in context by renderer in cli.mts and createHtmlTemplate.ts
 * Contains slug of current page/template (e.g. "registrace")
 */
export const pageSlugContextKey = "pageSlug";
